declare global {
    interface Window {
        fbq: (
            action: string,
            event: string,
            params?: Record<string, any>
        ) => void;
    }
}

export interface FacebookPixelEventParams {
    content_name?: string;
    content_category?: string;
    content_ids?: string[];
    contents?: Array<{
        id: string;
        quantity: number;
        item_price?: number;
    }>;
    currency?: string;
    value?: number;
    num_items?: number;
}

export const trackFacebookPixel = (
    event: string,
    params?: FacebookPixelEventParams
) => {
    if (typeof window !== "undefined" && window.fbq) {
        window.fbq("track", event, params);
    }
};

export const trackAddToCart = (params: {
    content_name: string;
    content_ids: string[];
    currency: string;
    value: number;
    num_items: number;
}) => {
    trackFacebookPixel("AddToCart", params);
};

export const trackInitiateCheckout = (params: {
    content_name?: string;
    content_ids?: string[];
    contents?: Array<{
        id: string;
        quantity: number;
        item_price?: number;
    }>;
    currency: string;
    value: number;
    num_items: number;
}) => {
    trackFacebookPixel("InitiateCheckout", params);
};

export const trackPurchase = (params: {
    content_name?: string;
    content_ids?: string[];
    contents?: Array<{
        id: string;
        quantity: number;
        item_price?: number;
    }>;
    currency: string;
    value: number;
    num_items: number;
}) => {
    trackFacebookPixel("Purchase", params);
};

export const trackViewContent = (params: {
    content_name: string;
    content_category?: string;
    content_ids?: string[];
    currency?: string;
    value?: number;
}) => {
    trackFacebookPixel("ViewContent", params);
};

export const trackAddPaymentInfo = (params: {
    content_name?: string;
    content_ids?: string[];
    currency: string;
    value: number;
}) => {
    trackFacebookPixel("AddPaymentInfo", params);
};

export const trackLead = (params?: {
    content_name?: string;
    value?: number;
    currency?: string;
}) => {
    trackFacebookPixel("Lead", params);
};

export const trackSearch = (params: {
    search_string: string;
    content_category?: string;
}) => {
    trackFacebookPixel("Search", params);
};
